(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ik-product-story')) return;

    var DESKTOP = '(min-width: 64em)';

    class IKProductStory extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-story-panel]'));
        this.anchors = Array.from(this.querySelectorAll('[data-story-anchor]'));
        this.overlays = Array.from(this.querySelectorAll('[data-story-overlay]'));
        this.reveals = Array.from(this.querySelectorAll('[data-story-reveal]'));
        this.activeIndex = null;

        this.mql = window.matchMedia(DESKTOP);
        this.onMediaChange = this.onMediaChange.bind(this);

        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.onMediaChange);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.onMediaChange);
        }

        this.startReveals();
        this.startStory();
      }

      disconnectedCallback() {
        this.stopStory();

        if (this.revealObserver) {
          this.revealObserver.disconnect();
          this.revealObserver = null;
        }

        if (this.mql) {
          if (this.mql.removeEventListener) {
            this.mql.removeEventListener('change', this.onMediaChange);
          } else if (this.mql.removeListener) {
            this.mql.removeListener(this.onMediaChange);
          }
        }
      }

      /* Fade intro / outro in once, on both breakpoints. */
      startReveals() {
        if (!this.reveals.length) return;

        if (!('IntersectionObserver' in window)) {
          this.reveals.forEach(function (el) {
            el.classList.add('is-revealed');
          });
          return;
        }

        this.revealObserver = new IntersectionObserver(
          function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
        );

        this.reveals.forEach(function (el) {
          this.revealObserver.observe(el);
        }, this);
      }

      /* Desktop only. Observe the TEXT BLOCK, not the whole panel.
         A panel box is a full viewport tall, so watching the box switches
         the image the moment the box edge crosses the middle — while its
         text is still most of a screen away. Watching the text block
         instead switches exactly when the words reach reading position. */
      startStory() {
        if (!this.anchors.length || !this.overlays.length) return;
        if (!this.mql.matches) return;

        if (!('IntersectionObserver' in window)) {
          this.setActive(0);
          return;
        }

        this.storyObserver = new IntersectionObserver(
          function (entries) {
            var mid = window.innerHeight / 2;
            var winner = null;
            var best = Infinity;

            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var r = entry.boundingClientRect;
              var d = Math.abs(r.top + r.height / 2 - mid);
              if (d < best) {
                best = d;
                winner = entry.target;
              }
            });

            if (!winner) return;

            var panel = winner.closest('[data-story-panel]');
            if (panel) this.setActive(Number(panel.dataset.index));
          }.bind(this),
          { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
        );

        this.anchors.forEach(function (anchor) {
          this.storyObserver.observe(anchor);
        }, this);
      }

      stopStory() {
        if (this.storyObserver) {
          this.storyObserver.disconnect();
          this.storyObserver = null;
        }

        this.activeIndex = null;
        this.removeAttribute('data-active');

        this.overlays.forEach(function (el) {
          el.classList.remove('is-active');
        });

        this.panels.forEach(function (el) {
          el.classList.remove('is-active');
        });
      }

      onMediaChange() {
        this.stopStory();
        this.startStory();
      }

      setActive(index) {
        if (index === this.activeIndex || Number.isNaN(index)) return;
        this.activeIndex = index;
        this.setAttribute('data-active', String(index));

        this.overlays.forEach(function (el) {
          el.classList.toggle('is-active', Number(el.dataset.index) === index);
        });

        this.panels.forEach(function (el) {
          el.classList.toggle('is-active', Number(el.dataset.index) === index);
        });
      }
    }

    customElements.define('ik-product-story', IKProductStory);
  })();

  } catch(e) { console.error(e); }
})();
})();
